import { apiClient } from '@/api/client'
import type { CardTransaction } from '@/api/types/card-transaction'

/** その日のカード利用のうち、レシートが無いものだけを返す（レシートがあればそちらを表示する） */
export const getUnmatchedCardTransactions = async (date: string, signal?: AbortSignal): Promise<CardTransaction[]> => {
  const res = await apiClient.get<CardTransaction[]>('/card-transactions', { params: { date }, signal })
  return res.data.filter((tx) => tx.receipt_id === null)
}
